import { render, staticRenderFns } from "./WithdrawInput.vue?vue&type=template&id=ed4c506a&lang=pug&"
import script from "./WithdrawInput.vue?vue&type=script&lang=ts&"
export * from "./WithdrawInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports